export type NationOrigin =
  | 'Russia' |'China' |'Iran' |'DPRK' |'eCrime';

export type Adversary = {
  id: string;
  name: string;
  animalType: string;
  origin: NationOrigin;
  apt?: string;
  description: string;
  // SVG-based avatar color scheme
  primaryColor: string;
  accentColor: string;
  emoji: string;
  image?: string;
};

export const ADVERSARIES: Adversary[] = [
  {
    id: 'fancy-bear',
    name: 'FANCY BEAR',
    animalType: 'BEAR',
    origin: 'Russia',
    apt: 'APT28',
    description: 'GRU military intelligence, credential phishing & spearphishing campaigns',
    primaryColor: '#3B82F6',
    accentColor: '#93C5FD',
    emoji: '🐻',
    image: '/assets/images/converted_image__7_-1787798213715.webp',
  },
  {
    id: 'cozy-bear',
    name: 'COZY BEAR',
    animalType: 'BEAR',
    origin: 'Russia',
    apt: 'APT29',
    description: 'SVR foreign intelligence, supply chain attacks, stealthy long-term access',
    primaryColor: '#1D4ED8',
    accentColor: '#60A5FA',
    emoji: '🐻',
    image: '/assets/images/converted_image__6_-1787798218337.webp',
  },
  {
    id: 'voodoo-bear',
    name: 'VOODOO BEAR',
    animalType: 'BEAR',
    origin: 'Russia',
    apt: 'Sandworm',
    description: 'Destructive attacks on critical infrastructure, wiper malware',
    primaryColor: '#7C3AED',
    accentColor: '#A78BFA',
    emoji: '🐻',
    image: '/assets/images/converted_image__5_-1787798223735.webp',
  },
  {
    id: 'gothic-panda',
    name: 'GOTHIC PANDA',
    animalType: 'PANDA',
    origin: 'China',
    apt: 'APT3',
    description: 'Defense & aerospace targeting, zero-day exploitation',
    primaryColor: '#CA8A04',
    accentColor: '#FDE047',
    emoji: '🐼',
    image: '/assets/images/converted_image__4_-1787798223735.webp',
  },
  {
    id: 'glacial-panda',
    name: 'GLACIAL PANDA',
    animalType: 'PANDA',
    origin: 'China',
    description: 'Telecom sector infiltration, stealthy persistent access',
    primaryColor: '#0891B2',
    accentColor: '#67E8F9',
    emoji: '🐼',
    image: '/assets/images/converted_image__2_-1787798249649.webp',
  },
  {
    id: 'scattered-spider',
    name: 'SCATTERED SPIDER',
    animalType: 'SPIDER',
    origin: 'eCrime',
    description: 'Social engineering, vishing, SIM swapping, ransomware deployment',
    primaryColor: '#EA580C',
    accentColor: '#FDBA74',
    emoji: '🕷️',
    image: '/assets/images/converted_image__1_-1787798249650.webp',
  },
  {
    id: 'famous-chollima',
    name: 'FAMOUS CHOLLIMA',
    animalType: 'CHOLLIMA',
    origin: 'DPRK',
    description: 'IT worker infiltration, GenAI-assisted identity fraud, insider threat',
    primaryColor: '#9333EA',
    accentColor: '#D8B4FE',
    emoji: '🦄',
    image: '/assets/images/converted_image-1787798249792.webp',
  },
  {
    id: 'ethereal-panda',
    name: 'ETHEREAL PANDA',
    animalType: 'PANDA',
    origin: 'China',
    description: 'Stealthy cyber-espionage targeting government and research institutions',
    primaryColor: '#059669',
    accentColor: '#6EE7B7',
    emoji: '🐼',
    image: '/assets/images/converted_image__3_-1787808824755.webp',
  },
];

export const ORIGIN_BADGE_CLASS: Record<NationOrigin, string> = {
  Russia: 'badge-russia',
  China: 'badge-china',
  Iran: 'badge-iran',
  DPRK: 'badge-dprk',
  eCrime: 'badge-ecrime',
};

export const ORIGIN_LABEL: Record<NationOrigin, string> = {
  Russia: 'Russia-nexus',
  China: 'China-nexus',
  Iran: 'Iran-nexus',
  DPRK: 'DPRK-nexus',
  eCrime: 'eCrime',
};